function asBadge(statusKey, row, vue) {
    const statusLabelOptions = vue.$store.state.orderStatusOptions.list;
    const statusOption = statusLabelOptions.find(item => item.key === statusKey);


  return statusOption !== undefined ? `<div class="font-weight-bolder text-uppercase" style="color: #${statusOption.hex_color}">${statusOption.internal_label}</div>`: '';
};

export default {
  asBadge
};
